import React, { useState, useEffect } from "react";

import { Box } from "@mui/material";
import { useAuth } from "../../../../context/AuthContext";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { useStateContext } from "../../../../context/StateContext_KO";

export default function EnterPayment(props) {
  // console.log(window.location.origin + "/success");
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState("");
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { currentUser } = useAuth();
  const { basket, getBasketTotal } = useStateContext();

  let address =
    props.shippingAddress.firstname +
    " " +
    props.shippingAddress.lastname +
    " - " +
    props.shippingAddress.address +
    props.shippingAddress.apt +
    " " +
    props.shippingAddress.city +
    " " +
    props.shippingAddress.state +
    " " +
    props.shippingAddress.zipcode;

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );
    console.log("clientSecret", clientSecret);

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      console.log(paymentIntent.status);
      switch (paymentIntent.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          break;
      }
      setIsLoading(false);
    });
  }, [stripe]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      setIsLoading(false);
      return;
    }
    sessionStorage.setItem("FinishCheckoutUSA", true);
    const result = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        // return_url: "http://localhost:3004/success",
        return_url: window.location.origin + "/success",
      },
    });

    if (result.error) {
      setIsLoading(false);
      // Show error to your customer (for example, payment details incomplete)
      setError(result.error.message);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  };

  return (
    <Box sx={{ pt: 7, px: 7 }}>
      <Box
        sx={{
          display: "flex",
          width: 1,
          borderBottom: "1px solid lightgray",
          paddingBottom: "10px",
        }}
      >
        <Box sx={{ pr: 4, width: "60px" }}>Email</Box>
        <Box sx={{ color: "#616161", fontWeight: "bold" }}>{props.email}</Box>
        <Box
          sx={{
            fontSize: "12px",
            color: "gray",
            marginLeft: "auto",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => props.goToFirstStep()}
        >
          Edit
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          width: 1,
          borderBottom: "1px solid lightgray",
          paddingBottom: "10px",
          paddingTop: "10px",
          fontSize: "12px",
        }}
      >
        <Box sx={{ pr: 4, width: "60px" }}>Address</Box>
        <Box sx={{ color: "#616161", fontWeight: "bold" }}>{address}</Box>
        <Box
          sx={{
            fontSize: "12px",
            color: "gray",
            marginLeft: "auto",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => props.goToStepTwo()}
        >
          Edit
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          width: 1,
          borderBottom: "1px solid lightgray",
          paddingBottom: "10px",
          paddingTop: "10px",
          fontSize: "12px",
        }}
      >
        <Box sx={{ pr: 4, width: "60px" }}>Shipping</Box>
        <Box sx={{ color: "#616161", fontWeight: "bold" }}>
          {props.shipping}
        </Box>
        <Box
          sx={{
            fontSize: "12px",
            color: "gray",
            marginLeft: "auto",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => props.goToPreviousStep()}
        >
          Edit
        </Box>
      </Box>

      <form
        id="payment-form"
        onSubmit={handleSubmit}
        style={{ paddingTop: "40px" }}
      >
        <Box sx={{ fontSize: "16px" }}>Card Payment</Box>
        <Box sx={{ py: 2, color: "blue" }}>{error && error}</Box>
        <PaymentElement id="payment-element" />
        <button
          className="custom_btn"
          style={{ marginTop: "20px" }}
          disabled={isLoading || !stripe || !elements}
          id="submit"
        >
          <span id="button-text">
            {isLoading ? <div>...Processing</div> : "Pay now"}
          </span>
        </button>
        {/* Show any error or success messages */}
        {/* {message && <div id="payment-message">{message}</div>} */}
      </form>
    </Box>
  );
}
